import { render } from "./Paso6RazonSocialComponent.vue?vue&type=template&id=dfb25d5c"
import script from "./Paso6RazonSocialComponent.vue?vue&type=script&lang=js"
export * from "./Paso6RazonSocialComponent.vue?vue&type=script&lang=js"

import "./Paso6RazonSocialComponent.vue?vue&type=style&index=0&id=dfb25d5c&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__